module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_long_grey.5418f350.png";